<template>
  <router-link
    v-if="changedItems.length && draftDossier && Object.keys(draftDossier).length"
    class="dossier-update-banner"
    :to="{ name: 'reconciliation', params: { entityExternalId: entityExternalId }}"
  >
    <div class="banner-content">
      <Icon
        class="banner-icon"
        icon="fas fa-exchange-alt"
      />
      We have updates for your dossier! 
    </div>
    <Button
      variant="success"
    >
      Review Changes
    </Button>
  </router-link>
</template>

<script setup>
import { toRef } from 'vue';
import { Button, Icon } from '@stakeui';
import { useDossierItems } from '@frontend/shared/composables/useDossierItems.js';

const props = defineProps({
  entityExternalId: {
    type: String,
    required: true,
  },
  draftDossier: {
    type: Object,
    required: false,
    default: () => ({}),
  },
});

const draftRef = toRef(props, 'draftDossier');

const {
  changedItems,
} = useDossierItems(draftRef);
</script>

<style scoped>
.dossier-update-banner {
  background-color: var(--stk-success-95);
  border: 1px solid var(--stk-success-60);
  border-radius: 1em;
  color: var(--stk-success-30);
  padding: 1em;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: background-color 0.2s;
  font-weight: 500;

  &:hover {
    background-color: var(--stk-success-90);
  }
}

.banner-content {
  display: flex;
  align-items: center;
}

.banner-icon {
  color: var(--stk-success-50);
  margin-right: 0.5em;
}
</style>
